import { all } from 'redux-saga/effects';
import getCredits from './credits';

export const creditSaga = function* root() {
  yield all([getCredits()]);
};
